import { configureStore } from '@reduxjs/toolkit';
import projectsSlice from './slices/projectsSlice';
import propertiesSlice from './slices/propertiesSlice';
import currentProjectSlice from './slices/currentProjectSlice';
import authSlice from './slices/authSlice';
import appSlice from './slices/appSlice';
import imagesSlice from './slices/imagesSlice';
import projectFilterSlice from './slices/projectFilterSlice';

export type TState = ReturnType<typeof store.getState>;
export type TAppDispatch = typeof store.dispatch;

const isDev = process.env.NODE_ENV === 'development';

const store = configureStore({
    reducer: {
        projects: projectsSlice,
        currentProject: currentProjectSlice,
        properties: propertiesSlice,
        auth: authSlice,
        app: appSlice,
        images: imagesSlice,
        projectFilter: projectFilterSlice,
    },
    devTools: isDev,
});

export default store;
